import React, { useState, useEffect } from 'react';
import { useAppContext } from '../../../hooks/AppContext';
import { prop } from 'ramda';
import usePrice from 'src/apps/envizi-price-estimator/hooks/usePrice';
import { swapCountryAndLanguage } from 'src/apps/envizi-price-estimator/utility/swapCountryAndLanguage';
import { IBMLocale } from 'src/common/locale/mapValidLocale';
import { ReactComponent as Bar } from 'src/apps/envizi-price-estimator/assets/Bar.svg';
import { SkeletonPlaceholder } from 'carbon-components-react';
import { CLIP_LEVEL } from 'src/apps/envizi-price-estimator/constant/prices';
import { FormattedMessage } from 'react-intl';
import messages from 'src/apps/envizi-price-estimator/locales/messages';
import { isEmpty } from 'ramda';
import { useSetCookie } from 'src/apps/envizi-price-estimator/hooks/useSetCookie';
import { useCookiesURL } from 'src/common/hooks/widgets/useCookiesURL';
import { SCOPE_3_POSITION } from '../../../constant/spread';
import { useLang } from 'src/common/hooks/widgets/useLang';
import countryList from '../../../services/currencies.json';

type PropsFunc = {
  isOpen: boolean;
  langCode: string;
  answers: answerProps[];
  insight: boolean;
  tileValue: string;
  countryToTest: string;
  test: boolean;
};

type answerProps = {
  state: string;
  answer: string;
};

const Result = ({
  isOpen,
  langCode,
  answers,
  insight,
  tileValue,
  countryToTest,
  test,
}: PropsFunc) => {
  const localeCode = swapCountryAndLanguage(langCode as IBMLocale);
  const { appState, appAction } = useAppContext();
  const appPoints = prop('appPoints')(appState);
  const cookieURL = useCookiesURL();
  const [currency, setCurrency] = useState('');
  const [country, setCountry] = useState('');
  const [] = useLang(
    countryList,
    test,
    countryToTest,
    setCurrency,
    setCountry,
    localeCode,
  );
  const [lowerPrice, higherPrice, usLowerPrice, loading] = usePrice({
    appPoints,
    localeCode,
    currency,
    tileValue,
    country,
  });

  const results: string[] = [];
  !isEmpty(answers) &&
    answers.map((item: answerProps) =>
      results.push(`${item.state} : ${item.answer.split('Cookie-')[1]}`),
    );
  const price = { lowerPrice, higherPrice };

  useEffect(() => {
    if (lowerPrice && higherPrice) {
      appAction({
        type: 'price',
        value: price,
      });
    }
  }, [lowerPrice, higherPrice]);

  const scope3Option = prop('scope3')(appState);
  const scope3Selection = `Scope 3 emissions : ${scope3Option}`;

  const getFinalResult = () => {
    // append the scoping 3 emission answer at index 4 in order to send answer to cookie in proper sequence
    for (let i = results.length; i > SCOPE_3_POSITION; i--) {
      results[i] = results[i - 1];
    }
    results[SCOPE_3_POSITION] = scope3Selection;
    return results;
  };

  const finalResults = scope3Option === 'No' ? getFinalResult() : results;
  useEffect(() => {
    if (appPoints && answers.length) {
      useSetCookie(
        appPoints,
        finalResults,
        cookieURL,
        lowerPrice as string,
        higherPrice as string,
      );
    }
  }, [appPoints, answers, lowerPrice, higherPrice]);

  return isOpen ? (
    <div>
      <div className="price-section">
        {(Number(usLowerPrice) < CLIP_LEVEL && isEmpty(scope3Option)) ||
        (Number(usLowerPrice) < CLIP_LEVEL &&
          !insight &&
          scope3Option === 'Yes') ||
        (Number(usLowerPrice) < CLIP_LEVEL && scope3Option === 'No') ? (
          <>
            <div className="page_sub_heading center">
              <FormattedMessage {...messages.estimatedCosts} />
              <sup className="envizi-sup">1</sup>
            </div>

            <div className="bar">
              <Bar />
            </div>

            <div className="price-table">
              <div className="price-table-row">
                {loading ? (
                  <SkeletonPlaceholder className="price-table-cell sticky-nav-skeleton" />
                ) : (
                  <div className="price_table_comp__heading price-table-cell">
                    {lowerPrice}
                  </div>
                )}
                {loading ? (
                  <SkeletonPlaceholder className="price-table-cell sticky-nav-skeleton" />
                ) : (
                  <div className="price_table_comp__heading price-table-cell">
                    {higherPrice}
                  </div>
                )}
              </div>
            </div>
            <div id="footnote">
              <div className="bx--row mar6 mar2">
                <div className="bx--col-lg-16">
                  <div>
                    <p>
                      <span className="footnote_num">1</span>
                    </p>
                  </div>
                  <div className="footnote_text">
                    <FormattedMessage {...messages.footnoteOne} />
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div id="footnote">
            <div className="bx--row mar6 mar2">
              <div className="bx--col-lg-16">
                <div className="page_sub_heading">
                  <FormattedMessage {...messages.custom_quote_msg} />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  ) : null;
};

export default Result;
